// ? 全局默认配置项

// * 默认主题颜色
export const DEFAULT_PRIMARY = '#FF556B'

// * Tabs（黑名单地址，不需要添加到 tabs 的路由地址）
export const TABS_BLACK_LIST: string[] = ['/login']

export const logoNYUrl: string =
  'https://static.hzpdex.com/web/1769061171109_wiio_logo.svg'
export const logoUrl: string =
  'https://file.securepago.com/ny/1769221045802_wiio payment logo.png'

// 邮箱正则表达式
export const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
